// Product-level permissions shared by the builder and cart editor.
window.ChanniMealOptions = window.ChanniMealOptions || (() => {
  const enabled = value => value === true || value === 1;
  const flags = value => ({ size16: enabled(value?.size16), roti: enabled(value?.roti), naan: enabled(value?.naan) });
  const customizable = meal => meal.allow.size16 || meal.allow.roti || meal.allow.naan;
  const defaultSide = meal => customizable(meal) ? 'rice' : 'none';
  const sideAllowed = (meal, side) => side === defaultSide(meal) || (['roti', 'naan'].includes(side) && meal.allow[side]);
  const normalize = (meal, selection) => ({ ...selection,
    size: meal.allow.size16 && Number(selection.size) === 16 ? 16 : 12,
    side: sideAllowed(meal, selection.side) ? selection.side : defaultSide(meal)
  });
  const assignment = (meals, mode) => {
    const result = meals.map(defaultSide);
    if (mode === 'roti' || mode === 'naan') meals.forEach((meal, index) => { if (meal.allow[mode]) result[index] = mode; });
    if (mode === 'half') {
      const flexible = []; let roti = 0, total = 0;
      meals.forEach((meal, index) => {
        if (!meal.allow.roti && !meal.allow.naan) return;
        total += 1;
        if (meal.allow.roti && meal.allow.naan) flexible.push(index);
        else if (meal.allow.roti) { result[index] = 'roti'; roti += 1; }
        else result[index] = 'naan';
      });
      const flexibleRotis = Math.max(0, Math.min(flexible.length, Math.ceil(total / 2) - roti));
      flexible.forEach((index, position) => { result[index] = position < flexibleRotis ? 'roti' : 'naan'; });
    }
    return result;
  };
  const sideCounts = (meals, mode) => assignment(meals, mode).reduce((counts, side) => { if (side === 'roti' || side === 'naan') counts[side] += 1; return counts; }, { roti: 0, naan: 0 });
  const modeAvailable = (meals, mode) => {
    if (mode === 'individual' || mode === 'rice') return true;
    const counts = sideCounts(meals, mode);
    return mode === 'half' ? counts.roti > 0 && counts.naan > 0 : counts[mode] > 0;
  };
  // Maximum assignable quantity after reserving space for the other bread.
  const maximum = (meals, kind, otherQuantity = 0) => {
    const own = meals.filter(meal => meal.allow[kind]).length;
    if (kind === 'size16') return own;
    const other = kind === 'roti' ? 'naan' : 'roti';
    const union = meals.filter(meal => meal.allow[kind] || meal.allow[other]).length;
    return Math.max(0, Math.min(own, union - otherQuantity));
  };
  const sideLabel = side => side === 'naan' ? 'Garlic naan' : side === 'none' ? 'Standard configuration' : side.charAt(0).toUpperCase() + side.slice(1);
  const mealDetail = (meal, selection, mode, serving) => {
    if (!customizable(meal)) return serving;
    const portion = meal.allow.size16 ? `${selection.size} oz` : serving;
    const side = ['roti', 'naan', 'half'].includes(mode) && ['roti', 'naan'].includes(selection.side) ? 'No rice' : sideLabel(selection.side);
    return `${portion} · ${side}`;
  };
  const boxLabel = (meals, mode) => {
    const counts = sideCounts(meals, mode);
    if (mode === 'roti') return `All roti (${counts.roti} rotis)`;
    if (mode === 'naan') return `All naan (${counts.naan} naans)`;
    if (mode === 'half') return `Half roti / half naan (${counts.roti} rotis + ${counts.naan} naans)`;
    return mode === 'rice' ? 'Keep rice' : 'Keep individual Roti/Naan substitutions';
  };
  return { flags, customizable, defaultSide, sideAllowed, normalize, assignment, sideCounts, modeAvailable, maximum, sideLabel, mealDetail, boxLabel };
})();
